const CurrentLocation = () => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path
      fill='none'
      fillRule='evenodd'
      stroke='#000'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M3 13L21 3 11 21l1-9z'
    />
  </svg>
);

export default CurrentLocation;
